<template>
  <div>
    <div class="danghang-every" v-if="isCommonH">
      <div class="mainContainer">
        <span>当前位置：</span><span>宣传教育图文详情</span>
      </div>
    </div>
    <div class="mainContainer">

      <el-card class="box-card">
        <div style="text-align: center;">
          <div style="font-size: 26px;margin: 30px 0;">{{infoData.title}}</div>
          <div><el-divider>{{infoData.description}}</el-divider></div>
          <div v-if="infoData.fileType=='1'" style="padding: 20px;overflow-x: hidden;"
            v-html="infoData.articleContent?infoData.articleContent:''">
          </div>
          <div v-if="infoData.fileType=='2'">
          </div>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
  export default {
    props: ['wjSrc'],
    data() {
      return {
        isCommonH: true,
        infoData: {},
        mp4Url: 'http://zhkt.tsanquan.com/jtzy/16/productXc/2023/3/21/5171bf5abd084a10b52ac9bef19178e3.mp4'
      }
    },
    methods: {
      getDetail: function(id) {
        this.$axios.get('/kt/productCourse/detail.htm?id=' + id, {
          headers: {
            "X-Requested-With": "XMLHttpRequest",
          }
        }).then(res => {
          this.infoData = res.data.data;
        })
      }
    },
    created() {
      this.getDetail(this.$route.query.id);
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Xjdetail.vue